import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "../Firebase Functions/firebase";
import { doc, setDoc, serverTimestamp, updateDoc } from "firebase/firestore";
import UploadPayoutRequestToQuickBase from "../Quickbase Functions/PayoutQBUpdate";
import "../TruckServices/ChecklistForm.css";

const PayoutRequestForm = () => {
  const location = useLocation();
  const incidentId = location.state?.incidentId;
  const navigate = useNavigate();

  const [modalMessage, setModalMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    company: "",
    description: "",
    amount: "",
    costCode: "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!incidentId) {
      setModalMessage("Missing incident ID. Please save the incident report first.");
      setShowModal(true);
      return;
    }

    try {
        const finalData = {
          ...formData,
          referenceId: incidentId,
          createdAt: serverTimestamp(),
          payoutRequestCompleted: true,
        };
      
        // Save to payoutRequests
        await setDoc(doc(db, "payoutRequests", incidentId), finalData);
        
        setModalMessage("Payout Request saved. Uploading to QuickBase...");
        setShowModal(true);
      
        // Upload to Quickbase
        await UploadPayoutRequestToQuickBase(incidentId);
      
        // ✅ Only update incidentReports if QuickBase upload succeeds
        await updateDoc(doc(db, "incidentReports", incidentId), {
          payoutRequestCompleted: true,
        });
      
        setModalMessage("✅ Payout Request uploaded to QuickBase successfully.");
      } catch (error) {
        console.error("Error saving or uploading:", error);
        setModalMessage("❌ Failed to save or upload. Please try again.");
      } finally {
        setShowModal(true);
        navigate('/saved-incident-reports');
      }
      
  };

  return (
    <form onSubmit={handleSubmit} className="checklist-form" noValidate>
      <h2 className="form-title">Payout Request</h2>

      <div className="form-group">
        <label>Company</label>
        <input
          type="text"
          value={formData.company}
          onChange={(e) => handleChange("company", e.target.value)}
          className="form-control"
        />
      </div>

      <div className="form-group">
        <label>Description</label>
        <input
          type="text"
          value={formData.description}
          onChange={(e) => handleChange("description", e.target.value)}
          className="form-control"
        />
      </div>

      <div className="form-group">
        <label>Amount</label>
        <input
          type="text"
          value={formData.amount}
          onChange={(e) => handleChange("amount", e.target.value)}
          className="form-control"
        />
      </div>

      <div className="form-group">
        <label>Cost Code</label>
        <input
          type="text"
          value={formData.costCode}
          onChange={(e) => handleChange("costCode", e.target.value)}
          className="form-control"
        />
      </div>

      <button type="submit" className="secondary-button" style={{ marginTop: "1.5rem" }}>
        Save Payout Request
      </button>

      {showModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal">
            <h2>Notice</h2>
            <p>{modalMessage}</p>
            <button className="modal-close-button" onClick={() => setShowModal(false)}>
              OK
            </button>
          </div>
        </div>
      )}
    </form>
  );
};

export default PayoutRequestForm;
